import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "customer"
    }}>{`Customer`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Login Customer`}</p>
    </blockquote>
    <p>{`In PickBazar Laravel, the end users who visit the website to explore, choose, and buy goods or services are represented by the customer role. Consumers create accounts, place orders, send money, and leave reviews.`}</p>
    <p><img alt="customer-profile" src={require("../../images/customer-profile.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Guest Customer`}</p>
    </blockquote>
    <p>{`A guest user in e-commerce refers to someone who visits an online store and makes purchases without creating an account or logging in. Without creating an account, PickBazar Guest visitors may explore goods, add things to their basket, enter shipping and payment details, and finish a transaction. For first-time customers or those who would rather not establish accounts, this simplified method is handy.`}</p>
    <p><img alt="customer-guest" src={require("../../images/guest-user.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      